import React, { FC } from 'react'

import { ErrorHandler } from 'components'
import { makeTraceDetails } from 'common'
import { isEmpty } from 'lodash'

import { DontDistubMessageView } from './DontDistubMessageView'
import { useDontDistubMessage } from '../hooks/useDontDistubMessage'

export const DontDistubMessage: FC = () => {
  const { content, isAppLoading, isErrorOrInactive, isActive } = useDontDistubMessage()

  if (isAppLoading) return null

  if (isErrorOrInactive || isEmpty(content)) {
    const traceDetails = makeTraceDetails(isActive, content)

    return <ErrorHandler traceDetails={traceDetails} componentName={DontDistubMessage.name} />
  }

  const { contentPartOne, site, contentPartTwo } = content

  return (
    <DontDistubMessageView
      contentPartOne={contentPartOne}
      contentPartTwo={contentPartTwo}
      site={site}
    />
  )
}
